import {
    ENVIRONMENT,
    STUDIO_MFE_REDIRECT_FLAG,
} from '@experiences/constants';
import { IntlProvider } from '@experiences/locales';
import { ApolloThemeProvider } from '@experiences/theme';
import {
    getEnvironment,
    getEnvVariableValue,
} from '@experiences/util';
import React, {
    useEffect,
    useState,
} from 'react';
import { Provider } from 'react-redux';
import { RouterProvider } from 'react-router';
import { SWRConfig } from 'swr';

import { getRouter } from './Router';
import store from './store';

const Router = React.memo(() => {
    const [ router, setRouter ] = useState<any>(undefined);

    useEffect(() => {
        getRouter().then(setRouter);
    }, []);

    return router ? <RouterProvider router={router} /> : null;
});

export const App = () => {
    const SWR_DEDUPE_INTERVAL = getEnvVariableValue('SWR_DEDUPE_INTERVAL');

    useEffect(() => {
        // Check for studio MFE redirect flag set by global app
        const redirectToSw = localStorage.getItem(STUDIO_MFE_REDIRECT_FLAG);
        const env = getEnvironment();

        if (redirectToSw && (env === ENVIRONMENT.LOCAL || env === ENVIRONMENT.ALP)) {
            // Extract organization name from current URL
            const pathMatch = window.location.pathname.match(/\/([^/]+)\/portal_/);
            const organizationName = pathMatch ? decodeURIComponent(pathMatch[1]) : '';

            // Remove the redirect flag
            localStorage.removeItem(STUDIO_MFE_REDIRECT_FLAG);

            if (organizationName) {
                window.location.replace(`${window.location.origin}/${organizationName}/studio_`);
            }
        }
    }, []);

    return (
        <Provider store={store}>
            <IntlProvider>
                <ApolloThemeProvider>
                    <SWRConfig
                        value={{
                            revalidateOnFocus: false,
                            dedupingInterval: ((window as any).Cypress ? 0 : SWR_DEDUPE_INTERVAL) ?? 2000,
                        }}
                    >
                        <Router />
                    </SWRConfig>
                </ApolloThemeProvider>
            </IntlProvider>
        </Provider>
    );
};
